import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type ManageOrganizationUserAction = 'approve' | 'reject' | 'deactivate' | 'remove';

export type ManageOrganizationUserResponse = {
  status: 'success' | 'noop';
  action: ManageOrganizationUserAction;
  userId: string;
  newStatus: string | null | undefined;
};

export type ManageOrganizationUserPayload = {
  organizationId: string;
  userId: string;
  action: ManageOrganizationUserAction;
};

export async function manageOrganizationUser(
  payload: ManageOrganizationUserPayload,
): Promise<ManageOrganizationUserResponse> {
  if (!payload.organizationId) {
    throw new Error('An organization id is required.');
  }
  if (!payload.userId) {
    throw new Error('A user id is required.');
  }

  const callable = httpsCallable<ManageOrganizationUserPayload, ManageOrganizationUserResponse>(
    functions,
    'manageOrganizationUser',
  );
  const result = await callable(payload);
  return result.data;
}
